import cx from 'classnames';
import React from 'react';

import { isValidUrl } from '@kitconcept/volto-iframe-block/helpers/isValidUrl';

const IframeView = (props) => {
  const { className, data, iframeRef, isEditMode } = props;
  const width =
    data.width && (data.width.includes('px') || data.width.includes('%'))
      ? data.width
      : `${data.width}px`;

  return (
    <div className={cx('block iframe', className)}>
      <div className={cx('iframe-container align', data.alignment)}>
        {data.src && isValidUrl(data.src) && (
          <figure style={{ width: width, maxWidth: '100%' }}>
            <iframe
              ref={iframeRef}
              src={data.src}
              title={data.title}
              height={
                data.preserveAspectRatio &&
                data.calculatedAspectRatio &&
                !isEditMode
                  ? 'auto'
                  : data.height
              }
              style={
                data.preserveAspectRatio && data.calculatedAspectRatio
                  ? { aspectRatio: data.calculatedAspectRatio.toString() }
                  : {}
              }
            />
            <figcaption>
              {data.title && <div className="title">{data.title}</div>}
              {data.description && (
                <div className="description">{data.description}</div>
              )}
              {data.credit && (
                <div className="credit">
                  <span>Credit:</span>
                  <div dangerouslySetInnerHTML={{ __html: data.credit.data }} />
                </div>
              )}
            </figcaption>
          </figure>
        )}
      </div>
    </div>
  );
};

export default IframeView;
